import {
  hide_goftino,
  open_goftino,
  send_goftino_message,
  toggle_goftino,
} from 'assets/js/plugins/goftino';

const useGoftino = () => {
  const is_loading = ref(typeof Goftino === 'undefined');

  if (import.meta.client) {
    window.addEventListener('goftino_ready', () => {
      is_loading.value = false;
    });
  }

  return {
    is_loading_goftino: is_loading,
    toggle_goftino,
    hide_goftino,
    open_goftino,
    send_goftino_message,
  };
};

export default useGoftino;
